import React, { useMemo } from 'react';
import { TableMeta } from '@tanstack/react-table';
import { ColumnDef } from '@tanstack/react-table';
import { Switch } from '@/components/ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface CustomTableMeta extends TableMeta<any> {
  updateData: (rowIndex: number, columnId: string, value: any) => void;
}

type UpdateDataValue = boolean | string;

interface UpdateDataArgs {
  rowIndex: number;
  columnId: string;
  value: UpdateDataValue;
  table: any;
}

export const updateTableCellData = ({ rowIndex, columnId, value, table }: UpdateDataArgs): void => {
  const meta = table.options.meta as CustomTableMeta;
  meta?.updateData(rowIndex, columnId, value);
};

export const useHealthStatusChangeTable = () => {
  const columns: ColumnDef<any>[] = useMemo(() => {
    return [
      {
        accessorKey: 'asset_ui_name',
        header: 'Site Name & Asset Name',
        cell: ({ row }) => {
          const { site_name, asset_ui_name } = row.original;

          return (
            <div>
              <div>{asset_ui_name}</div>
              <div className="text-sm text-gray-500">{site_name}</div>
            </div>
          );
        },
        enableFiltering: false,
        size: 400,
      },
      {
        accessorKey: 'to_healthy',
        header: 'Back to Healthy Status',
        cell: ({ row, column, table }) => {
          const value = row.original.parameters.find((param: any) => param.name === 'to_healthy')?.value;

          const handleToggle = (value: boolean) => {
            updateTableCellData({
              rowIndex: row.index,
              columnId: column.id,
              value,
              table,
            });
          };

          return <Switch checked={value} onCheckedChange={handleToggle} />;
        },
        enableFiltering: false,
      },
      {
        accessorKey: 'minimum_health_status',
        header: 'Minimum Unhealthy Status',
        cell: ({ row, column, table }) => {
          const value = row.original.parameters.find((param: any) => param.name === 'minimum_health_status')?.value;
          const options = ['critical', 'alarm', 'monitor', 'none'];

          const handleChange = (value: string) => {
            updateTableCellData({
              rowIndex: row.index,
              columnId: column.id,
              value,
              table,
            });
          };

          return (
            <Select value={value.toLowerCase()} onValueChange={handleChange}>
              <SelectTrigger className="w-[180px] capitalize">
                <SelectValue placeholder="Select status" />
              </SelectTrigger>
              <SelectContent>
                {options.map((option) => (
                  <SelectItem key={option.toLowerCase()} value={option.toLowerCase()} className="capitalize">
                    {option}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          );
        },
        enableFiltering: false,
      },
    ];
  }, []);
  return {
    columns,
  };
};
